"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _accordion = _interopRequireWildcard(require("../accordion"));

var _pill = _interopRequireDefault(require("../pill"));

var _index = _interopRequireDefault(require("./index.scss"));

var FiltersSmall = function FiltersSmall(_ref) {
  var children = _ref.children,
      countDisplay = _ref.countDisplay,
      onClick = _ref.onClick,
      idPrefix = _ref.idPrefix,
      heading = _ref.heading;
  return _react["default"].createElement(_accordion["default"], {
    headerElement: _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", null, heading || 'Filters'), countDisplay && _react["default"].createElement(_pill["default"], {
      className: _index["default"].accordionCount,
      type: "secondary",
      dataTestId: idPrefix && "".concat(idPrefix, "-items-count-small")
    }, countDisplay)),
    visible: false,
    type: _accordion.AccordionSize.Small,
    classNames: _index["default"],
    id: idPrefix && "".concat(idPrefix, "-filters"),
    onClick: onClick
  }, children);
};

var _default = FiltersSmall;
exports["default"] = _default;